import { ESSENTIALS_CONTENT_CATEGORY } from '../../essentials/types'
import { CMS_MICROSITE_MESSAGE_KEY } from '../messages/messages'
import { CMS_MICROSITE_ID, CMSMicrositeMetadata } from '../types'

/** CIS Political Uncertainty toolkit */
export const cisPoliticalUncertaintyToolkitMetadata: CMSMicrositeMetadata = {
  micrositeId: CMS_MICROSITE_ID.CIS_POLITICAL_UNCERTAINTY,
  iFrameSrcUrl: '/political-uncertainty-cis-toolkit',
  micrositeUrl: 'political-uncertainty-cis-toolkit',
  title: {
    id: 'cisPoliticalUncertainty.title',
    defaultMessage: 'Dealing with political uncertainty',
    description: 'Microsite page title',
  },
  featureFlag: 'oct2025ToolkitsEnabled',
  customerPropertyConditions: [
    {
      key: 'libraryDisabled',
      value: true,
    },
  ],
  postMessageEvents: [
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_WEBINAR_EVENTS },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.CLICK_SELF_CARE_CONTENT,
    },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.REGISTER_WEBINAR,
      params: {
        webinarLink: '/secure/index/essentials/events',
      },
    },
    { key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_FORKED_TRIAGE },
    {
      key: CMS_MICROSITE_MESSAGE_KEY.NAVIGATE_TO_ESSENTIALS,
      params: {
        category: ESSENTIALS_CONTENT_CATEGORY.TOPIC,
        slug: 'coping-with-crisis',
      },
    },
  ],
  page: 'CIS political uncertainty',
  trackUTMParams: {
    utm_campaign: 'CISpoliticaluncertainty',
  },
  customMixpanelEventProps: {
    toolkit_topic: 'CISpoliticaluncertainty',
  },
  shouldHideForInternational: true,
}
